import React, { useEffect, useRef, useState } from "react";
//import SriyanshCardHeader from "../../../components/CardHeader";
import { Box, Card, CardContent, Typography } from "@mui/material";
//import { BoxStyle } from "../../../constantVaribles/constatanvariable";
//import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import DropdownfromDatabaseList from "../../../CustomComponant/DropdownfromDatabaseList";
//import DatePickerComponent from "../../../CustomComponant/DateTimePickerField";
import PoReport from "../Po/PoReport";
import apiClient from "../../../BaseUrl/apiClient.js";
import { useAuthentication } from "../../../customHook/useAuthentecation";
import { USER_RIGHTS } from "../../../constants/constants";
import TokenService from "../../../service/TokenService";
import CircularProgress from "@mui/material/CircularProgress";

const GeneralReports = () => {
  const reportRef = useRef(null);
  const { auth } = useAuthentication();
  const tokenServiceDetails = TokenService.getUserDetails();
  const consigee_consignee = tokenServiceDetails?.consignee;
  const [consignee, setconsignee] = useState("");
  const [consignees, setconsignees] = useState([]);
  // const today = dayjs();

  const [reports, setreports] = useState([]);
  const [report, setreport] = useState("");
  const [subreport, setsubreport] = useState("");
  const [subreports, setsubreports] = useState([]);

  const [generateReportClick, setgenerateReportClick] = useState(false);

  // const [dateFrom, setdateFrom] = useState(dayjs());
  // const [dateTo, setdateTo] = useState(dayjs());

  const [pageLoader, setPageLoader] = useState(false);

  // Function to get the key based on the selected value

  const reportgenerateClick = (event) => {
    setgenerateReportClick(true);
  };

  const navigate = useNavigate();
  // Function to fetch Consignee from the API

  const fetchConsignees = async () => {
    try {
      //setPageLoader(true);
      const response = await apiClient.post("/ConsigneeList", {
        /* request payload if needed */
      });
      setconsignees(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    } finally {
      setPageLoader(false);
    }
  };

  // Function to fetch Consignee from the API
  const fetchReportList = async () => {
    try {
      const response = await apiClient.post("/ReportsList", {
        /* request payload if needed */
      });
      setreports(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const fetchsubReportList = async () => {
    try {
      const response = await apiClient.post("/subReportsList", {
        /* request payload if needed */
      });
      setsubreports(response.data);

      // Assuming response.data is an array of roles
      //console.log(response.data);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    fetchConsignees();
    fetchReportList();
    fetchsubReportList();
  }, []);

  useEffect(() => {
    // Update state if roles change (in case roles are updated dynamically)
    if (consignees.length > 0) {
      if (auth?.userrights === USER_RIGHTS.CONSIGNEE) {
        setconsignee(consigee_consignee);
      } else {
        setconsignee(consignees[0].ConsigneeCode);
      }
    }

    if (reports.length > 0) {
      setreport(reports[0].reportcode);
    }

     if (subreports.length > 0) {
      setsubreport("All Data");
     }
  }, [consignees, reports, subreports,auth?.userrights,consigee_consignee]);

  const handleClose = () => {
    navigate("/../dashboard", { replace: true });
  };

  const reportData = {
    consignee: consignee,
    reporttype: report,
    reportsubtype: subreport,
  };
  useEffect(() => {
    // Reset the report display when report or subreport changes
   
    setgenerateReportClick(false);

   

  }, [report, consignee]);


  useEffect(() => {
    if (generateReportClick && reportRef.current) {
      reportRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [generateReportClick]);


 return (
  <Box
    sx={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      boxSizing: "border-box",
      overflowX: "hidden",
      p: { xs: 1, sm: 1.5, md: 2 },
    }}
  >
    <Card
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        overflow: "hidden",
        borderRadius: { xs: 2, md: 2.5 },
        border: "1px solid #dbe5f0",
        boxShadow: "0 4px 18px rgba(13, 71, 161, 0.10)",
        backgroundColor: "#fff",
      }}
    >
      {/* ================= HEADER ================= */}
      <Box
        sx={{
          background:
            "linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%)",
          color: "#fff",
          px: { xs: 1.5, sm: 2, md: 2.5 },
          py: { xs: 1.4, sm: 1.6 },
          minHeight: { xs: 54, sm: 60 },
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "1rem", sm: "1.15rem", md: "1.3rem" },
            fontWeight: 700,
          }}
        >
          Admin Reports
        </Typography>
      </Box>

      <CardContent
        sx={{
          p: { xs: 1.25, sm: 2, md: 2.5 },
          "&:last-child": {
            pb: { xs: 1.5, sm: 2, md: 2.5 },
          },
        }}
      >
        {/* ================= REPORT FILTER SECTION ================= */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            boxSizing: "border-box",
            border: "1px solid #dbe5f0",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          {/* SECTION HEADER */}
          <Box
            sx={{
              px: { xs: 1.25, sm: 1.75 },
              py: 1,
              background:
                "linear-gradient(135deg, #e3f2fd 0%, #f5f9ff 100%)",
              borderBottom: "1px solid #dbe5f0",
            }}
          >
            <Typography
              sx={{
                color: "#0D47A1",
                fontWeight: 700,
                fontSize: { xs: "0.9rem", sm: "1rem" },
              }}
            >
              Report Selection
            </Typography>
          </Box>

          <Box
            sx={{
              p: { xs: 1.25, sm: 2, md: 2.5 },
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, minmax(0, 1fr))",
                lg: "repeat(3, minmax(0, 1fr))",
              },
              gap: { xs: 1.5, sm: 2 },
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              boxSizing: "border-box",
            }}
          >
            {/* ================= CONSIGNEE ================= */}
            <Box
              sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
              }}
            >
              {pageLoader ? (
                <Box
                  sx={{
                    minHeight: 42,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress size={28} />
                </Box>
              ) : (
                <DropdownfromDatabaseList
                  Options={consignees}
                  option={consignee}
                  setOptionValue={setconsignee}
                  DisplayItem1="Shop"
                  DisplayItem2="ConsigneeCode"
                  showKeyInLabel={true}
                  disableLabel="Select Consignee from List"
                  allDataLabel="Select All"
                  disabled={
                    auth?.userrights === USER_RIGHTS.CONSIGNEE
                  }
                />
              )}
            </Box>

            {/* ================= REPORT ================= */}
            <Box
              sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
              }}
            >
              {pageLoader ? (
                <Box sx={{ minHeight: 42 }} />
              ) : (
                <DropdownfromDatabaseList
                  Options={reports}
                  option={report}
                  setOptionValue={setreport}
                  DisplayItem1="reporttype"
                  DisplayItem2="reportcode"
                  disableLabel="Select Report from List"
                />
              )}
            </Box>

            {/* ================= SUB REPORT ================= */}
            <Box
              sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
              }}
            >
              <DropdownfromDatabaseList
                Options={subreports.filter(
                  (subreportItem) =>
                    subreportItem.mainreport === report
                )}
                option={subreport}
                setOptionValue={setsubreport}
                DisplayItem1="subreporttype"
                DisplayItem2="reportid"
                disableLabel="Select Sub Report from List"
              />
            </Box>
          </Box>
        </Box>

        {/* ================= SELECTED REPORT SUMMARY ================= */}
        {/* <Box
          sx={{
            mt: { xs: 1.5, sm: 2 },
            p: { xs: 1.25, sm: 1.5 },
            borderRadius: 2,
            background:
              "linear-gradient(135deg, #eef6ff 0%, #f7fbff 100%)",
            border: "1px solid #cfe2ff",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "0.72rem", sm: "0.78rem" },
              color: "#607d8b",
              mb: 0.4,
            }}
          >
            Selected Report
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "0.82rem", sm: "0.9rem" },
              fontWeight: 700,
              color: "#0D47A1",
              overflowWrap: "anywhere",
              wordBreak: "break-word",
            }}
          >
            {report || "Not Selected"}
            {"  "}
            {subreport ? `— ${subreport}` : ""}
          </Typography>
        </Box> */}

        {/* ================= ACTION BUTTONS ================= */}
        <Box
          sx={{
            mt: { xs: 1.5, sm: 2 },
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, minmax(0, 1fr))",
            },
            gap: 1.25,
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
          }}
        >
          <button
            className="button button1"
            type="button"
            onClick={reportgenerateClick}
            title="Click for Report Generate"
            disabled={generateReportClick}
            style={{
              width: "100%",
              minHeight: "42px",
              border: "none",
              borderRadius: "8px",
              background: generateReportClick
                ? "#90a4ae"
                : "linear-gradient(135deg, #0D47A1 0%, #1565C0 100%)",
              color: "#fff",
              fontWeight: 700,
              cursor: generateReportClick
                ? "not-allowed"
                : "pointer",
              boxShadow: generateReportClick
                ? "none"
                : "0 3px 8px rgba(13, 71, 161, 0.22)",
            }}
          >
            Generate Report
          </button>

          <button
            className="button button1"
            type="button"
            onClick={handleClose}
            title="Close Report"
            style={{
              width: "100%",
              minHeight: "42px",
              border: "none",
              borderRadius: "8px",
              background:
                "linear-gradient(135deg, #c62828 0%, #e53935 100%)",
              color: "#fff",
              fontWeight: 700,
              cursor: "pointer",
              boxShadow:
                "0 3px 8px rgba(198, 40, 40, 0.20)",
            }}
          >
            Close Report
          </button>
        </Box>

        {/* ================= REPORT OUTPUT ================= */}
        {generateReportClick && (
          <Box
            id="report"
            ref={reportRef}
            sx={{
              mt: { xs: 2, sm: 2.5 },
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              boxSizing: "border-box",
              overflowX: "hidden",
              border: "1px solid #dbe5f0",
              borderRadius: 2,
              backgroundColor: "#fff",
            }}
          >
            <Box
              sx={{
                px: { xs: 1.25, sm: 1.75 },
                py: 1,
                background:
                  "linear-gradient(135deg, #e3f2fd 0%, #f5f9ff 100%)",
                borderBottom: "1px solid #dbe5f0",
              }}
            >
              <Typography
                sx={{
                  color: "#0D47A1",
                  fontWeight: 700,
                  fontSize: { xs: "0.9rem", sm: "1rem" },
                }}
              >
                Report
              </Typography>
            </Box>

            <Box
              sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                overflowX: "hidden",
              }}
            >
              <PoReport
                consignee={reportData.consignee}
                reporttype={reportData.reporttype}
                reportsubtype={reportData.reportsubtype}
              />
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  </Box>
);
};

export default GeneralReports;
